var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconmoney = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "#f3123c",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25,50A25,25,0,1,1,50,25,25.028,25.028,0,0,1,25,50ZM25,5A20,20,0,1,0,45,25,20.023,20.023,0,0,0,25,5Zm-.059,34.254h-.79l-.709-.617a2.277,2.277,0,0,1-.6-1.737V35.535A12.181,12.181,0,0,1,18.063,32.8a2.2,2.2,0,0,1-.3-2.9l.518-.725,1.069-.142h.081a2.15,2.15,0,0,1,1.46.537,7.419,7.419,0,0,0,3.962,1.946l.353,0a3.842,3.842,0,0,0,2.356-.83,2.02,2.02,0,0,0,.819-1.5,1.4,1.4,0,0,0-.7-1.208A7.573,7.573,0,0,0,24.8,26.854l-.466-.092a10.859,10.859,0,0,1-4.187-1.775,5.478,5.478,0,0,1-2.293-4.446,6.463,6.463,0,0,1,4.982-6.014V13.174a2.353,2.353,0,0,1,.6-1.814L24,10.8l.945-.052a2.179,2.179,0,0,1,2.142,2.428v1.352a11.872,11.872,0,0,1,3.9,2.147,2.157,2.157,0,0,1,.549,2.871l-.4.659-.884.3a2.151,2.151,0,0,1-.516.063,2.116,2.116,0,0,1-1.19-.362c-1.311-.963-2.257-1.6-3.411-1.645l-.414,0a3.531,3.531,0,0,0-1.922.738,1.73,1.73,0,0,0-.671,1.24c0,.279.045.565.59.986a6.522,6.522,0,0,0,2.435.995l.437.088a12.272,12.272,0,0,1,4.635,1.881l.027.02a5.759,5.759,0,0,1,2.4,4.671,6.809,6.809,0,0,1-5.562,6.431v1.213A2.18,2.18,0,0,1,24.941,39.254Z",
    transform: "translate(2 2)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconmoney, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconmoney.38fe5c22.svg";
export { ForwardRef as ReactComponent };